import { computed, DestroyRef, effect, inject, input, model, signal } from '@angular/core';
import { CrudManagerService } from '@common/crud-ui/frontend-shared';
import { GenerateMediaAssetSubtitlesRequest, MediaAssetsHelper, MediaAssetSubtitlesItem, SyncMediaAssetSubtitlesRequest, vttCueNodeObjectNames } from '@common/media/shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { AppMessageFactory, AppRequestService, CrudServiceFactory, takeWhileAlive } from '@core/frontend-shared';
import { DynamicDialogRef } from 'prime-ng-old/dynamicdialog';
import { debounceTime, filter, take } from 'rxjs';
import { WebVTTParser, WebVTTSerializer } from 'webvtt-parser';
import { MediaAssetProvidersFrontendService } from '../../provider';
import { MediaAssetTimelineComponent } from '../media-asset-timeline';
import { TimelineItemEvent, TimelineItemsEvent, TimelineItemsUpdated, TimelineItemUpdated } from '../media-asset-timeline/timeline-events';
import { TimelineService } from '../media-asset-timeline/timeline.service';
import { MediaAssetSubtitlesCueEditorComponent } from './media-asset-subtitles-cue-editor.component';
import { SubtitlesImportExportComponent } from './subtitles-import-export.component';
import { ConfirmDialogService } from '@common/ui/frontend-shared/confirmdialog';
import { UiInputSwitchComponent } from '@common/ui/frontend-shared/input-switch';
import { FormsModule } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
const _c0 = () => ["Status: Unsichtbar", "Status: Sichtbar f\u00FCr Nutzer"];
function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const info_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", info_r3.error, " ");
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onClickGenerateAiSubtitles());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_6_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onClickSyncSubtitles());
    });
    i0.ɵɵelementEnd();
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1, "Der Host hat keine Funktionen zur Auto-Generierung von Untertiteln.");
    i0.ɵɵelementEnd();
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "media-asset-subtitles-cue-editor", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 6)(5, "ui-input-switch", 7);
    i0.ɵɵlistener("ngModelChange", function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Template_ui_input_switch_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setSubtitleItemEnabled($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(6, MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_6_Template, 2, 0)(7, MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_7_Template, 2, 0, "p", 8);
    i0.ɵɵelementStart(8, "div", 6)(9, "button", 9);
    i0.ɵɵlistener("click", function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openImportExport("import"));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 10);
    i0.ɵɵlistener("click", function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.openImportExport("export"));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("timeline", ctx_r1.timeline);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", (tmp_6_0 = ctx_r1.subtitlesItem()) == null ? null : tmp_6_0.enabled)("labels", i0.ɵɵpureFunction0(4, _c0));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.features().generateSubtitles ? 6 : 7);
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_0_Template, 2, 1, "div", 1)(1, MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Conditional_1_Template, 11, 5, "div", 2);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.error ? 0 : 1);
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "media-asset-timeline", 0);
    i0.ɵɵlistener("onAddItemAt", function MediaAssetSubtitlesManagerComponent_Conditional_0_Template_media_asset_timeline_onAddItemAt_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleAddItemAt($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(1, MediaAssetSubtitlesManagerComponent_Conditional_0_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("subtitles", ctx_r1.livePreviewSubtitles())("timeline", ctx_r1.timeline);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_4_0 = ctx_r1.timeline.assetInfo()) ? 1 : -1, tmp_4_0);
  }
}
function MediaAssetSubtitlesManagerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-content-centered");
    i0.ɵɵelement(1, "ui-spinner");
    i0.ɵɵelementEnd();
  }
}
const NEW_VTT_TEMPLATE = `WEBVTT

00:00.000 --> 00:01.000
Neuer Untertitel

`;
const TRACK_ID_MAIN = 1;
export let MediaAssetSubtitlesManagerComponent = /*#__PURE__*/(() => {
  class MediaAssetSubtitlesManagerComponent {
    constructor() {
      this.mediaProviders = inject(MediaAssetProvidersFrontendService);
      this.dialog = inject(DynamicDialogRef, {
        optional: true
      });
      this.crudManager = inject(CrudManagerService, {
        optional: true
      });
      this.crud = inject(CrudServiceFactory).useDestroyRef(inject(DestroyRef)).createCrudService(MediaAssetSubtitlesItem).useCrudEndpoint('admin');
      this.api = inject(AppRequestService);
      this.messages = inject(AppMessageFactory);
      this.timeline = inject(TimelineService);
      this.dialogService = inject(DynamicDialogService);
      this.confirmationService = inject(ConfirmDialogService);
      this.vttCueNodeObjectNames = vttCueNodeObjectNames;
      this.vttParser = new WebVTTParser();
      this.vttSerializer = new WebVTTSerializer();
      this.enablePlayer = input(true, ...(ngDevMode ? [{
        debugName: "enablePlayer"
      }] : /* istanbul ignore next */[]));
      this.assetInput = model(null, ...(ngDevMode ? [{
        debugName: "assetInput"
      }] : /* istanbul ignore next */[]));
      this.asset = computed(() => {
        const item = this.assetInput();
        if (item) return item;
        if (this.crudManager) {
          const modeAndItem = this.crudManager.getCurrentModeAndItem();
          if (modeAndItem?.item) return modeAndItem.item;
        }
        // if(!IS_PRODUCTION && !item) throw new Error('MediaAssetSubtitlesManagerComponent received no item! Either set input or ensure a CrudManagerService is available and configurated.')
        return null;
      }, ...(ngDevMode ? [{
        debugName: "asset"
      }] : /* istanbul ignore next */[]));
      this.subtitlesItem = model(null, ...(ngDevMode ? [{
        debugName: "subtitlesItem"
      }] : /* istanbul ignore next */[]));
      this.hasSubtitles = computed(() => {
        const item = this.subtitlesItem();
        return item && typeof item.data === 'string' && item.data.length > 0;
      }, ...(ngDevMode ? [{
        debugName: "hasSubtitles"
      }] : /* istanbul ignore next */[]));
      this.provider = computed(() => {
        const item = this.asset();
        if (!item) return null;
        return this.mediaProviders.getProvider(item);
      }, ...(ngDevMode ? [{
        debugName: "provider"
      }] : /* istanbul ignore next */[]));
      this._changeAsset = effect(() => {
        const asset = this.asset();
        if (asset) this.timeline.asset.set(asset);
        const existingSubtitles = MediaAssetsHelper.findAssetSubtitles(asset);
        if (existingSubtitles) {
          this.subtitlesItem.set(existingSubtitles);
        } else {
          this.crud.create({
            assetId: asset.id,
            enabled: false,
            data: ""
          }).subscribe(item => {
            this.subtitlesItem.set(item);
          });
        }
      }, ...(ngDevMode ? [{
        debugName: "_changeAsset"
      }] : /* istanbul ignore next */[]));
      this._changeSubtitleItem = effect(() => {
        const subtitlesItem = this.subtitlesItem();
        this.timeline.tracks.set([{
          id: TRACK_ID_MAIN
        }]);
        const vtt = subtitlesItem?.data;
        if (vtt) {
          const timelineItems = this.parseWebVttData(subtitlesItem.data);
          this.timeline.items.set(timelineItems);
          this.previewSubtitles(vtt);
        } else {
          this.timeline.items.set([]);
        }
      }, ...(ngDevMode ? [{
        debugName: "_changeSubtitleItem"
      }] : /* istanbul ignore next */[]));
      this.livePreviewSubtitles = signal([], ...(ngDevMode ? [{
        debugName: "livePreviewSubtitles"
      }] : /* istanbul ignore next */[]));
      this._enablePlayer = effect(() => this.timeline.enablePlayer.set(this.enablePlayer()), ...(ngDevMode ? [{
        debugName: "_enablePlayer"
      }] : /* istanbul ignore next */[]));
      // _pxPerSec = effect(()=>this.timeline.pxPerSec.set(this.pxPerSec()))
      // _currPositionSec = effect(()=>this.timeline.currPositionSec.set(this.currPositionSec()))
      // _selection = effect(()=>this.timeline.selection.set(this.selection()))
      // timeline does not know about VTT data. to keep it in sync, we subscribe to itemUpdate events.
      // whenever a change happens, this will update VTT data and send the refreshed data into timeline.
      this.syncVttDataWhenUpdated = this.timeline.events$.pipe(filter(e => e instanceof TimelineItemUpdated || e instanceof TimelineItemsUpdated), debounceTime(100), takeWhileAlive()).subscribe(e => {
        let items = e instanceof TimelineItemsUpdated ? e.items : [e.item];
        // this little trick of serialize & re-parse helps to ensure timeline item properties are up to date (label, time)
        items.sort((a, b) => b.start - a.start);
        const vtt = this.generateWebVttData(items);
        const parsed = this.parseWebVttData(vtt);
        // sync Cue & timeline item data
        // while calling timeline.updateItems() would be more efficient,
        // we prefer to keep the modifications as granular as possible
        // and only change the data where needed.
        items.forEach((item, i) => {
          const parsedItem = parsed[i];
          this.timeline.updateItemData(item.id, parsedItem.data);
          this.timeline.updateItemLabel(item.id, parsedItem.label);
        });
      });
      this.saveVttWhenChanged = this.timeline.events$.pipe(filter(e => e instanceof TimelineItemEvent || e instanceof TimelineItemsEvent), debounceTime(1000), takeWhileAlive()).subscribe(e => {
        const vtt = this.generateWebVttData(this.timeline.items());
        this.saveSubtitles(vtt);
        this.previewSubtitles(vtt);
      });
      this.features = computed(() => {
        const provider = this.provider();
        return {
          generateSubtitles: provider.features.generateSubtitles
        };
      }, ...(ngDevMode ? [{
        debugName: "features"
      }] : /* istanbul ignore next */[]));
    }
    previewSubtitles(vtt) {
      const blobUrl = URL.createObjectURL(new Blob([vtt], {
        type: "text/plain"
      }));
      this.livePreviewSubtitles.set([{
        src: blobUrl,
        lang: 'de-DE',
        label: 'Deutsch',
        isDefault: true
      }]);
    }
    onClickAbort() {
      if (this.dialog) {
        this.dialog.close();
      }
    }
    handleAddItemAt(e) {
      this.timeline.addItem(e.trackId, e.seconds, 'neu', this.createEmptyCue(e.seconds));
    }
    createEmptyCue(start) {
      const items = this.vttParser.parse(NEW_VTT_TEMPLATE, 'subtitles');
      const newCue = items.cues[0];
      newCue.startTime = start;
      newCue.endTime = start + 1;
      return newCue;
    }
    saveSubtitles(vtt) {
      const subtitlesItem = this.subtitlesItem();
      if (!subtitlesItem) {
        throw new Error('tried to save subtitles but subtitlesItem is not existing yet!');
      } else {
        this.crud.update({
          id: subtitlesItem.id,
          data: vtt
        }).subscribe();
      }
    }
    setSubtitleItemEnabled(enabled) {
      const subtitlesItem = this.subtitlesItem();
      if (!subtitlesItem) {
        throw new Error('tried to save subtitles but subtitlesItem is not existing yet!');
      } else {
        this.crud.update({
          id: subtitlesItem.id,
          enabled
        }).subscribe();
      }
    }
    generateWebVttData(items) {
      const cues = items.map(item => {
        // NOTE: theres a bug in vtt serializer.
        // it will round ms to 3 decimals but if it rounds from 0.9996+ to 1.000
        // it will not add 1 second. easy workaround is to round values manually before passing.
        const cue = {
          ...item.data,
          startTime: +item.start.toFixed(3),
          endTime: +item.end.toFixed(3)
        };
        return cue;
      });
      cues.sort((a, b) => a.startTime - b.startTime);
      const vtt = this.vttSerializer.serialize(cues);
      return vtt;
    }
    parseWebVttData(data) {
      if (data === null) {
        return [];
      }
      const items = this.vttParser.parse(data, 'subtitles');
      if (items.errors.length > 0) {
        console.error(data);
        throw new Error('parseWebVttData failed with errors: \n' + items.errors.map(e => e.message).join('\n'));
      }
      const stripSpeakerTagRegex = /^<[^>]+>/;
      const timelineItems = items.cues.map((cue, i) => {
        return {
          id: i,
          track: TRACK_ID_MAIN,
          label: cue.text.replace(stripSpeakerTagRegex, ''),
          start: cue.startTime,
          end: cue.endTime,
          data: cue
        };
      });
      return timelineItems;
    }
    openImportExport(mode) {
      const header = mode === 'import' ? 'Import' : 'Export';
      const ref = this.dialogService.open(SubtitlesImportExportComponent, {
        header,
        width: '800px',
        contentStyle: {
          "overflow": "auto"
        },
        baseZIndex: 10000,
        padded: false,
        // closeOnEscape:true,
        dismissableMask: true,
        // maximizable: true,
        data: {
          mode,
          webVtt: mode === 'export' ? this.generateWebVttData(this.timeline.items()) : null
        }
      });
      ref.onClose.pipe(take(1)).subscribe(result => {
        if (result?.webVtt) {
          this.timeline.items.set(this.parseWebVttData(result.webVtt));
          const vtt = this.generateWebVttData(this.timeline.items());
          this.saveSubtitles(vtt);
        }
      });
    }
    onClickGenerateAiSubtitles() {
      const asset = this.asset();
      if (!asset?.id) throw new Error('No Asset set');
      const proceed = () => {
        this.api.sendRequest(GenerateMediaAssetSubtitlesRequest, {
          assetId: asset.id
        }).subscribe(response => {
          this.messages.create().setSeverity('success').setSummary('Untertitel-Generierung gestartet').setMessage('Die Untertitel-Generierung mittels KI ist ein asynchroner Prozess. Es dauert daher eine Weile, bis die Untertitel verfügbar sind.');
        });
      };
      if (!this.hasSubtitles()) {
        proceed();
      } else {
        this.confirmationService.confirm({
          header: 'Bestätigung erforderlich',
          message: 'Für das Asset sind bereits Untertitel vorhanden. Sind Sie sicher, dass neue Untertitel generiert werden sollen?',
          accept: () => proceed()
        });
      }
    }
    onClickSyncSubtitles() {
      const asset = this.asset();
      if (!asset?.id) throw new Error('No Asset set');
      const proceed = () => {
        const existingSubtitles = MediaAssetsHelper.findAssetSubtitles(asset);
        this.api.sendRequest(SyncMediaAssetSubtitlesRequest, {
          assetId: asset.id,
          subtitleId: existingSubtitles ? existingSubtitles.id : undefined
        }).subscribe(response => {
          this.messages.create().setSeverity('success').setSummary('Untertitel synchronisiert').setMessage("");
          if (this.assetInput() !== null) {
            // explicit item is set
            this.assetInput.set(response.updatedAsset);
          } else if (this.crudManager) {
            // implicit item from crudManager is being used
            this.crudManager.reload();
          }
        });
      };
      if (!this.hasSubtitles()) {
        proceed();
      } else {
        this.confirmationService.confirm({
          header: 'Bestätigung erforderlich',
          message: 'Die bestehenden Untertitel werden überschrieben. Möchten Sie fortfahren?',
          accept: () => proceed()
        });
      }
    }
    // ngOnInit() {this.setDemoVttData()}
    setDemoVttData() {
      this.timeline.items.set(this.parseWebVttData(`WEBVTT

00:08.000 --> 00:10.000
Astrophysicist, Director of the Hayden Planetarium
Other second line

00:11.000 --> 00:13.000 vertical:rl
<v Roger Bingham>We are in New York City

00:13.000 --> 00:16.000
<v Roger Bingham>We're actually at the Lucern Hotel, just down the street

00:16.000 --> 00:18.000
<v Roger Bingham>from the American Museum of Natural History

00:18.000 --> 00:20.000
<v Roger Bingham>And with me</v><v Peter Meyer> is Neil deGrasse Tyson
`));
    }
    static {
      this.ɵfac = function MediaAssetSubtitlesManagerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MediaAssetSubtitlesManagerComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MediaAssetSubtitlesManagerComponent,
        selectors: [["media-asset-subtitles-manager"]],
        hostVars: 2,
        hostBindings: function MediaAssetSubtitlesManagerComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("fill-space", true);
          }
        },
        inputs: {
          enablePlayer: [1, "enablePlayer"],
          assetInput: [1, "assetInput"],
          subtitlesItem: [1, "subtitlesItem"]
        },
        outputs: {
          assetInput: "assetInputChange",
          subtitlesItem: "subtitlesItemChange"
        },
        features: [i0.ɵɵProvidersFeature([TimelineService])],
        decls: 2,
        vars: 1,
        consts: [[3, "onAddItemAt", "subtitles", "timeline"], [1, "error"], [1, "editor"], [1, "left"], [3, "timeline"], [1, "right"], [1, "ui-margin"], [3, "ngModelChange", "ngModel", "labels"], [1, "ui-text-grey"], ["uiButton", "", "label", "Untertitel importieren", 1, "ui-width-stretch", "ui-button-grey", 3, "click"], ["uiButton", "", "label", "Untertitel exportieren", 1, "ui-width-stretch", "ui-button-grey", 3, "click"], ["uiButton", "", "label", "Untertitel mit KI generieren", 1, "ui-width-stretch", "ui-button-primary", 3, "click"], ["uiButton", "", "label", "KI-Untertitel manuell laden", 1, "ui-width-stretch", "ui-button-grey", 3, "click"]],
        template: function MediaAssetSubtitlesManagerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MediaAssetSubtitlesManagerComponent_Conditional_0_Template, 2, 3)(1, MediaAssetSubtitlesManagerComponent_Conditional_1_Template, 2, 0, "ui-content-centered");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.asset()) ? 0 : 1, tmp_0_0);
          }
        },
        dependencies: [MediaAssetTimelineComponent, UiButtonComponent, MediaAssetSubtitlesCueEditorComponent, UiContentCenteredComponent, UiSpinnerComponent, UiInputSwitchComponent, FormsModule, i1.NgControlStatus, i1.NgModel],
        styles: [".fill-space[_nghost-%COMP%]{position:absolute;inset:0;display:flex;flex-direction:column}.editor[_ngcontent-%COMP%]{display:flex;flex:1}.left[_ngcontent-%COMP%]{padding:20px;flex:1;overflow-y:auto}.right[_ngcontent-%COMP%]{padding:20px;width:300px;background:var(--backgroundSofterColor)}\n\n/*# sourceMappingURL=media-asset-subtitles-manager.component.ts-angular-inline--86.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return MediaAssetSubtitlesManagerComponent;
})();